import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateEntityRightsForUserMutation } from "org/user/queries/useUpdateEntityRightsForUserMutation";

import { EntityRow } from "./useUserEntitiesListTable";

interface UseRemoveEntityAccessRightUtilsProps {
    userId: number;
    selectedRows: Row<EntityRow>[];
    deselectAll: () => void;
}

export function useRemoveEntityAccessRightUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemoveEntityAccessRightUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate, isPending, error, reset } =
        useUpdateEntityRightsForUserMutation();

    const removeAccessRightToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeAccessRight = () => {
        const entityIds = selectedRows.map((row) => row.original.id);
        mutate(
            { userId, data: { newUserId: null, entityIds } },
            {
                onSuccess: () => {
                    deselectAll();
                    setIsModalOpen(false);
                },
                // On failure the modal stays open; `error` drives the notice.
            }
        );
    };

    return {
        removeAccessRightToolState,
        isRemoveAccessRightModalOpen: isModalOpen,
        removeAccessRightError: error,
        // Reset on open (not close) so the notice stays put during the close
        // animation and a stale error can't reappear next time.
        openRemoveAccessRightModal: () => {
            reset();
            setIsModalOpen(true);
        },
        closeRemoveAccessRightModal: () => setIsModalOpen(false),
        removeAccessRight,
        isRemovingAccessRight: isPending,
    };
}
